<template>
  <component
    :is="tag"
    :class="smartCardClass"
    class="smart-card__wrapper relative rounded bg-white">
    <slot />
  </component>
</template>

<script>
// @flow
export default {
  name: 'SmartCard',
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    shadow: {
      type: String,
      default: 'small',
      validator(value: string): boolean {
        return ['none', 'small', 'large'].includes(value);
      }
    },
    border: {
      type: String,
      default: 'true',
      validator(value: string): string {
        return ['true', 'false'].includes(value);
      }
    }
  },
  computed: {
    smartCardClass() {
      return `smart-card--${this.shadow}` + this.border === 'true' ? ' border-default' : '';
    },
  }
};
</script>

<style lang="scss">

</style>
